import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import '@splidejs/splide/css/core';

const logoSliders = document.querySelectorAll('.c-logo-slider__container');

if (logoSliders) {
  logoSliders.forEach((logoSlider) => {
    new Splide(logoSlider, {
      autoplay: `${(window.matchMedia('prefers-reduced-motion')) ? false : true}`,
      autoWidth: true,
      autoHeight: true,
      arrows: true,
      classes: {
        arrows: 'splide__arrows c-logo-slider__reduced-motion-arrows',
        arrow : 'splide__arrow c-logo-slider__reduced-motion-arrow',
        prev  : 'splide__arrow--prev c-logo-slider__reduced-motion-prev',
        next  : 'splide__arrow--next c-logo-slider__reduced-motion-next',
      },
      clones: 0,
      fixedWidth: 180,
      gap: '1.25rem',
      interval: 2000,
      keyboard: true,
      lazyLoad: 'nearby',
      pagination: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      perMove: 1,
      rewind: true,
      rewindSpeed: 500,
      type: 'loop',
      speed: 500,
    }).mount();
  });
}
